import { useCallback, useMemo } from "react";
import { useFieldArray } from "react-hook-form";

import { GoogleFreeBookingLinksPhoneType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { GoogleFreeBookingLinksSettingsContextType } from "../../../_context";

type Props = {
	form: GoogleFreeBookingLinksSettingsContextType["form"];
};

export const useFormPhoneNumbers = ({ form }: Props) => {
	const { fields, append, remove } = useFieldArray({
		control: form.control,
		name: "phoneNumbers",
	});

	const handleClickRemovePhoneNumber = useCallback(
		(index: number) => () => {
			remove(index);
		},
		[remove],
	);

	const handleClickAppendPhoneNumber = useCallback(() => {
		append({
			phoneNumber: "",
			phoneType: GoogleFreeBookingLinksPhoneType.Main,
		});
	}, [append]);

	const disabledAppendPhoneNumber = useMemo(() => {
		return fields.length >= 5;
	}, [fields]);

	const phoneTypeOptions = useMemo<Array<FormOptionType>>(
		() => [
			{
				id: GoogleFreeBookingLinksPhoneType.Main,
				label: "メイン",
				value: GoogleFreeBookingLinksPhoneType.Main,
			},
			{
				id: GoogleFreeBookingLinksPhoneType.Fax,
				label: "ファックス",
				value: GoogleFreeBookingLinksPhoneType.Fax,
			},
			{
				id: GoogleFreeBookingLinksPhoneType.Mobile,
				label: "携帯電話",
				value: GoogleFreeBookingLinksPhoneType.Mobile,
			},
			{
				id: GoogleFreeBookingLinksPhoneType.Tdd,
				label: "聴覚障害者向け電話リレーサービス（TDD）",
				value: GoogleFreeBookingLinksPhoneType.Tdd,
			},
			{
				id: GoogleFreeBookingLinksPhoneType.Tollfree,
				label: "フリーダイヤル",
				value: GoogleFreeBookingLinksPhoneType.Tollfree,
			},
		],
		[],
	);

	return {
		phoneNumberFields: fields,
		handleClickAppendPhoneNumber,
		handleClickRemovePhoneNumber,
		disabledAppendPhoneNumber,
		phoneTypeOptions,
	};
};
